import React from 'react';

export interface TooltipTriggerProps {
  children: React.ReactNode;
}

const TooltipTrigger = ({ children }: TooltipTriggerProps) => <>{children}</>;

TooltipTrigger.displayName = 'ToolingCoverageTooltip.Trigger';

export default TooltipTrigger;
